/**
 * App-wide config constants.
 *
 * BOOKING_URL is the live Microsoft Bookings page Tyler uses for discovery
 * calls. The client "Coravu Managed → Book a discovery call" path embeds it
 * in an iframe and exposes a "Open in a new tab" fallback. The transient
 * ?ismsaljsauthenabled query param Microsoft sometimes appends has been
 * stripped — it's an auth flag that isn't needed for the public page.
 *
 * If Bookings sends X-Frame-Options: DENY/SAMEORIGIN, the iframe will be
 * blank but the fallback link still works.
 */
export const BOOKING_URL =
  "https://outlook.office.com/book/CoravuIntake@Coravu.com/";

export const BOOKING_PROVIDER: "bookings" | "calendly" = "bookings";
